import { Copy } from 'almanac-ui/icons/16'
import { InlineFormatButton } from 'components/InlineFormatBar/components/InlineFormatButton/InlineFormatButton'
import { useState } from 'react'

export const CopyToClipboardInlineFormatButton = ({
  copyText,
  initialLabel = 'Copy URL',
}: {
  copyText: string
  initialLabel?: string
}) => {
  const [label, setLabel] = useState(initialLabel)

  const onClick = () => {
    navigator.clipboard.writeText(copyText)
    setLabel('Copied!')
    setTimeout(() => {
      setLabel('Copy URL')
    }, 1000)
  }

  return (
    <InlineFormatButton data-testid="copyToClipboard" label={label} onPress={onClick}>
      <Copy />
    </InlineFormatButton>
  )
}
